import React from 'react';
import { createRoot } from 'react-dom/client';
import MechanicAssessment from './MechanicAssessment.jsx';
import instrument from '../instruments/vintage-mechanic-v1.json';
import './styles.css';

// Demo bootstrap. In production, you'd import MechanicAssessment into your
// own React app and pass it your own instrument + endpoints.
function Demo() {
  const params =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search)
      : new URLSearchParams();

  const adminMode = params.get('admin') === '1';
  const submissionsMode = params.get('submissions') === '1';
  const token = params.get('token') || '';

  const leadEndpoint = import.meta.env.VITE_LEAD_ENDPOINT || '/api/leads';
  const submissionEndpoint =
    import.meta.env.VITE_SUBMISSION_ENDPOINT || '/api/submissions/:sessionId';
  const adminEndpoint =
    import.meta.env.VITE_ADMIN_ENDPOINT || '/api/admin/submissions';

  // Fail loudly in production if env vars are missing. The fallback paths
  // (/api/leads, etc.) only exist in local dev with a custom server — in
  // production they 404, causing the cryptic "Could not reach the assessment
  // service" UX. Better to refuse to render than to silently lead-capture
  // into the void.
  if (
    import.meta.env.PROD &&
    (!import.meta.env.VITE_LEAD_ENDPOINT ||
      !import.meta.env.VITE_SUBMISSION_ENDPOINT ||
      !import.meta.env.VITE_ADMIN_ENDPOINT)
  ) {
    return (
      <div style={{ minHeight: '100vh', padding: '40px 16px', background: '#F5F1EA', fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ maxWidth: 720, margin: '60px auto', background: '#fff', border: '2px solid #C84B4B', borderRadius: 8, padding: 32 }}>
          <h1 style={{ color: '#C84B4B', marginTop: 0 }}>Configuration error</h1>
          <p>This deployment is missing required environment variables:</p>
          <ul>
            {!import.meta.env.VITE_LEAD_ENDPOINT && <li><code>VITE_LEAD_ENDPOINT</code></li>}
            {!import.meta.env.VITE_SUBMISSION_ENDPOINT && <li><code>VITE_SUBMISSION_ENDPOINT</code></li>}
            {!import.meta.env.VITE_ADMIN_ENDPOINT && <li><code>VITE_ADMIN_ENDPOINT</code></li>}
          </ul>
          <p style={{ color: '#666', fontSize: 14 }}>
            Set these in the hosting platform's environment variables and redeploy.
            They must be set at build time — Vite inlines them into the bundle.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', padding: '40px 16px', background: '#F5F1EA' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <MechanicAssessment
          instrument={instrument}
          leadEndpoint={leadEndpoint}
          submissionEndpoint={submissionEndpoint}
          adminEndpoint={adminEndpoint}
          adminMode={adminMode}
          submissionsMode={submissionsMode}
          adminToken={token}
          branding={{ companyName: 'Hollywood Mechanic' }}
        />
        {import.meta.env.DEV && (
          <div style={{ textAlign: 'center', marginTop: 24, fontSize: 12, color: '#8A7E6C' }}>
            Demo views ·{' '}
            <a style={{ color: '#8A7E6C' }} href="?">candidate flow</a> ·{' '}
            <a style={{ color: '#8A7E6C' }} href="?seed=demo">demo flow (no gate)</a> ·{' '}
            <a style={{ color: '#8A7E6C' }} href="?admin=1">instrument preview</a> ·{' '}
            <a style={{ color: '#8A7E6C' }} href="?submissions=1">submissions admin</a>
          </div>
        )}
      </div>
    </div>
  );
}

createRoot(document.getElementById('root')).render(<Demo />);
